export default "/institutions/meliuz.svg";